import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fd3d4ed")

_pushScopeId("data-v-2fd3d4ed")
const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file" }, null, -1)
const _hoisted_2 = { class: "p-m-2" }
const _hoisted_3 = {
  key: 0,
  class: "pi pi-exclamation-triangle kn-warning-icon",
  "data-test": "warning-icon"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-m-2" }
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_8 = { class: "name-help p-m-0" }
const _hoisted_9 = { class: "p-m-2" }
const _hoisted_10 = { class: "kn-material-input-label" }
const _hoisted_11 = { class: "p-d-flex p-jc-end" }
const _hoisted_12 = { class: "p-m-2" }
const _hoisted_13 = { class: "p-ml-2" }
const _hoisted_14 = {
  key: 0,
  class: "p-mt-4"
}
const _hoisted_15 = {
  key: 1,
  class: "p-m-2"
}
const _hoisted_16 = { class: "p-my-4" }
const _hoisted_17 = { class: "p-ml-2" }
const _hoisted_18 = {
  key: 2,
  class: "p-mt-4"
}
const _hoisted_19 = { class: "p-m-2" }
const _hoisted_20 = { class: "kn-material-input-label" }
const _hoisted_21 = {
  key: 0,
  class: "p-error p-grid p-m-2"
}
const _hoisted_22 = { class: "p-m-2" }
const _hoisted_23 = { class: "kn-material-input-label" }
const _hoisted_24 = {
  key: 0,
  class: "p-error p-grid p-m-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_SchedulerDocumentAccordionTree = _resolveComponent("SchedulerDocumentAccordionTree")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Accordion, { activeIndex: 0 }, {
    default: _withId(() => [
      _createVNode(_component_AccordionTab, null, {
        header: _withId(() => [
          _hoisted_1,
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('managers.scheduler.saveAsDocument')), 1),
          (_ctx.document.invalid?.invalidDocument)
            ? (_openBlock(), _createBlock("i", _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        default: _withId(() => [
          (_ctx.document)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('common.name')) + " *", 1),
                    _createVNode(_component_InputText, {
                      class: ["kn-material-input", {
                                'p-invalid': _ctx.documentNameDirty && (!_ctx.document.documentname || _ctx.document.documentname.length === 0)
                            }],
                      modelValue: _ctx.document.documentname,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.document.documentname = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.document.nameMaxLength,
                      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateDocument('documentNameDirty'))),
                      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateDocument('documentNameDirty')))
                    }, null, 8, ["modelValue", "class", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", null, [
                      _withDirectives(_createVNode("div", { class: "p-error p-grid p-m-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.name') })), 513), [
                        [_vShow, _ctx.documentNameDirty && (!_ctx.document.documentname || _ctx.document.documentname.length === 0)]
                      ])
                    ]),
                    _createVNode("p", _hoisted_8, _toDisplayString(_ctx.nameHelp), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", null, [
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.description')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input",
                      modelValue: _ctx.document.documentdescription,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.document.documentdescription = $event)),
                      maxLength: _ctx.schedulerTimingOutputOutputTabDescriptor.accordion.document.descriptionMaxLength
                    }, null, 8, ["modelValue", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("small", null, _toDisplayString(_ctx.descriptionHelp), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_Checkbox, {
                    modelValue: _ctx.document.useFixedFolder,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.document.useFixedFolder = $event)),
                    binary: true,
                    onChange: _ctx.validateDocument
                  }, null, 8, ["modelValue", "onChange"]),
                  _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('managers.scheduler.fixedFolder')), 1)
                ]),
                (_ctx.document.useFixedFolder)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode(_component_SchedulerDocumentAccordionTree, {
                        propFunctionalities: _ctx.functionalities,
                        propSelectedFolders: _ctx.document.funct,
                        onSelected: _ctx.setSelectedFolders
                      }, null, 8, ["propFunctionalities", "propSelectedFolders", "onSelected"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.drivers.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _withDirectives(_createVNode("div", _hoisted_16, [
                        _createVNode(_component_Checkbox, {
                          modelValue: _ctx.document.useFolderDataset,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.document.useFolderDataset = $event)),
                          binary: true
                        }, null, 8, ["modelValue"]),
                        _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('managers.scheduler.folderFromDataset')), 1)
                      ], 512), [
                        [_directive_tooltip, 
                            `${_ctx.$t('managers.scheduler.useFolderDatasetHint.partOne')}:
                            ${_ctx.$t('managers.scheduler.useFolderDatasetHint.partTwo')} ${_ctx.$t('managers.scheduler.useFolderDatasetHint.partThree')}`
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.document.useFolderDataset)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("span", null, [
                          _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('managers.scheduler.datasetVerification')) + " *", 1),
                          _createVNode(_component_Dropdown, {
                            class: ["kn-material-input", {
                                    'p-invalid': _ctx.datasetFolderLabelDrity && (!_ctx.document.datasetFolderLabel || _ctx.document.datasetFolderLabel?.length === 0)
                                }],
                            modelValue: _ctx.document.datasetFolderLabel,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.document.datasetFolderLabel = $event)),
                            options: _ctx.datasets,
                            optionLabel: "label",
                            optionValue: "label",
                            filter: true,
                            filterMatchMode: "contains",
                            filterFields: ['label'],
                            onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.validateDocument('datasetFolderLabelDrity'))),
                            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateDocument('datasetFolderLabelDrity')))
                          }, null, 8, ["modelValue", "options", "class"]),
                          (_ctx.datasetFolderLabelDrity && (!_ctx.document.datasetFolderLabel || _ctx.document.datasetFolderLabel?.length === 0))
                            ? (_openBlock(), _createBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('managers.scheduler.datasetVerification') })), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("span", null, [
                          _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('common.driver')) + " *", 1),
                          _createVNode(_component_Dropdown, {
                            class: ["kn-material-input", {
                                    'p-invalid': _ctx.datasetFolderParameterDirty && (!_ctx.document.datasetFolderParameter || _ctx.document.datasetFolderParameter?.length === 0)
                                }],
                            modelValue: _ctx.document.datasetFolderParameter,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.document.datasetFolderParameter = $event)),
                            options: _ctx.drivers,
                            onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateDocument('datasetFolderParameterDirty'))),
                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validateDocument('datasetFolderParameterDirty')))
                          }, null, 8, ["modelValue", "options", "class"]),
                          (_ctx.datasetFolderParameterDirty && (!_ctx.document.datasetFolderParameter || _ctx.document.datasetFolderParameter?.length === 0))
                            ? (_openBlock(), _createBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.driver') })), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})